<div class="fa-dark" (click)="sendMail()" container="body">
  <i class="fa fa-reply btn-reply" aria-hidden="true"></i>
</div>
